import axios from 'axios';
import { SOCKET_ID_NAME } from '../utils/consts';

export const sendStat = (typeEvent: number = 1) => {
  const token = localStorage.getItem('token');
  if (!token || token === 'null' || token === 'undefined') return console.log('-> error - could not get token');
  const socket = localStorage.getItem(SOCKET_ID_NAME);
  if (!socket) return console.log('-> error - could not get socket id');
  axios
    .post('https://counter.expertus.com.ua/api/astat', {
      token,
      reffer: document.referrer,
      url: window.location,
      siteId: 88,
      siteSec: '7GDcn12sblk2',
      typeEvent,
      socket,
    })
    .then(function (response) {
      // console.log(response); // можно после тестирования закоментить
    })
    .catch(function (error) {
      // console.log(error); // можно после тестирования закоментить
    });
};
